module.exports = __webpack_public_path__ + "img/completa_la_promo.08208a0a.png";